export default __webpack_public_path__ + "static/Elido-Book-de35e86913d3291af2c4dfd5798a381a.woff2";